import React, { useState } from "react";
import { Button, ButtonGroup, Card, Stack } from "@chakra-ui/react";
import { t } from "i18next";
import { observer } from "mobx-react";
import { ProseMirrorWrapper } from "./ProseMirrorWrapper";
import { CraComment } from "../../models/CraComment";
import { useStores } from "../../../shared/stores/RootStore";
import { toast } from "../../../shared/views/CustomToaster";

interface Props {
  comment?: CraComment;
  onClose?: () => void;
}
const CommentEditorBase: React.FC<Props> = ({ comment, onClose }) => {
  const { craCommentStore } = useStores();
  const [markdown, setMarkdown] = useState("");

  const submitComment = () => {
    if (markdown) {
      craCommentStore.updateComment(comment?.id!, { content: markdown });
      onClose?.();
    } else {
      toast("error", t(`map:comments.emptySubmit`));
    }
  };

  return (
    <Stack gap={2}>
      <Card.Root variant="outline">
        <ProseMirrorWrapper
          defaultContent={comment?.content}
          onChange={setMarkdown}
        />
      </Card.Root>
      <ButtonGroup size="sm" alignSelf="end" colorPalette="primary">
        {!!onClose && (
          <Button variant="ghost" onClick={onClose}>
            {t(`map:comments.cancel`)}
          </Button>
        )}
        <Button onClick={submitComment}>{t(`map:comments.submit`)}</Button>
      </ButtonGroup>
    </Stack>
  );
};

export const CommentEditor = observer(CommentEditorBase);
